import { CrudStoreBase } from './crudStoreBase';
import { DocumentsDto } from '../services/documents/dto/documentsDto';
import documentsService from '../services/documents/documentsService';
import { defaultUser } from './userCrudStore';
import { defaultClient } from './clientStore';
import { DocumentTypeEnum } from '../services/documents/dto/documentTypeEnums';
import { DocumentStatusEnum } from '../services/documents/dto/documentStatusEnums';

class DocumentsStore extends CrudStoreBase<DocumentsDto>{
	constructor() {
		super(documentsService, defaultDocuments)
	}
}

export const defaultDocuments: DocumentsDto = {
	id: '',
    agent: defaultUser,
    agentId: 0,
    agentFullName: '',
    client: defaultClient,
    clientId: 0,
    clientFullName: '',
    documentType: DocumentTypeEnum.Communication,
    status: DocumentStatusEnum.Prepared,
    creationTime: '',
    attachedFiles: [],
}

export default DocumentsStore;